'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var Spinner = require('@narvar/nth-bit-icon-spinner');
var Typography = require('./Typography.js');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Spinner__default = /*#__PURE__*/_interopDefaultLegacy(Spinner);

// LoadingView will fill the space of LoadingContainer
// The caveat being if there's any UI in the tree
// between LoadingView and LoadingContainer that's also
// position: relative. But for the purpose of claims, this works.
const LoadingContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1q49t9z-0"
})(_ref => {
  let {
    loading
  } = _ref;
  return {
    position: 'relative',
    overflow: loading ? 'hidden' : undefined
  };
});

// z-index battle with the sticky version of nth-bundle-dynamic-header
// https://github.com/narvar/nth/blob/master/packages/nth-bundle-dynamic-header/src/index.tsx#L130-L139
const LoadingView = styled__default["default"].div.withConfig({
  componentId: "sc-1q49t9z-1"
})(_ref2 => {
  let {
    s
  } = _ref2;
  return {
    position: 'absolute',
    zIndex: 1000,
    left: 0,
    top: 0,
    height: '100%',
    width: '100%',
    background: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    ...s
  };
});
const Loading = _ref3 => {
  let {
    loading,
    text,
    width,
    children
  } = _ref3;
  const {
    documentbodyNoneNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(LoadingContainer, {
    loading: loading
  }, children, loading && /*#__PURE__*/React__default["default"].createElement(LoadingView, {
    role: "status",
    s: documentbodyNoneNone
  }, /*#__PURE__*/React__default["default"].createElement(Spinner__default["default"], {
    s: {
      width: width ?? '2rem'
    }
  }), /*#__PURE__*/React__default["default"].createElement(Typography.TertiaryHeader, {
    as: "span",
    s: {
      textTransform: 'none',
      marginTop: '1rem'
    }
  }, text)));
};
var Loading$1 = nthHookTheme.withThemeProvider(Loading, {
  themeTokens: ['documentbodyNoneNone']
});

exports.LoadingContainer = LoadingContainer;
exports["default"] = Loading$1;
